
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/mubinso-gajokjang",
      function () {
        return require("private-next-pages/guide/mubinso-gajokjang.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/mubinso-gajokjang"])
      });
    }
  